export var NEW_DOCUMENTS_ALERT = "Tenant.Documents.New.Alert";
